import React from 'react';
import i18n from '../../i18n';
import {withFormik} from 'formik';
import axios from 'axios';
import {withStyles} from "@material-ui/core";
import {mergeWithDefault} from "../Form/utils";
import swal from "sweetalert";
import {array, object, string, boolean, required, mixed} from "yup";
import CustomerFormFields from './CustomerFormFields'

class CustomerForm extends React.Component {

    render() {

        return <CustomerFormFields {...this.props}/>

    }

}

const FormConfig = withFormik({
    mapPropsToValues: props => {
        return mergeWithDefault(props.values, {
            contact_type: '',
            tenant_since: '',
            search_number: '',
            first_name: '',
            last_name: '',
            company_name: '',
            department: '',
            street: '',
            housenumber: '',
            zip: '',
            city: '',
            telephone: '',
            email: '',
            website: '',
            salutation: '',
            customer_name: '',
            customer_number: '',
            board_contact: '',
        });
    },

    validationSchema: () => {
        let rules = object().shape({
            customer_name: string().required(
                i18n.get('validation.required', {attribute: i18n.get('boards.board_name')})
            ),
            customer_number: string().required(
                i18n.get('validation.required', {attribute: i18n.get('boards.customer_number')})
            ),
            first_name: string().required(
                i18n.get('validation.required', {attribute: i18n.get('boards.first_name')})
            ),
            last_name: string().required(
                i18n.get('validation.required', {attribute: i18n.get('boards.last_name')})
            ),
            street: string().required(
                i18n.get('validation.required', {attribute: i18n.get('boards.street')})
            ),
            housenumber: string().required(
                i18n.get('validation.required', {attribute: i18n.get('boards.housenumber')})
            ),
            zip: string().required(
                i18n.get('validation.required', {attribute: i18n.get('boards.zip')})
            ),
            city: string().required(
                i18n.get('validation.required', {attribute: i18n.get('boards.city')})
            ),
        });

        return rules
    },

    handleSubmit: (values, {props}) => {
        axios.post(props.formUrl, values).then(() => {
            swal({
                icon: "success",
                title: i18n.get('contacts.save_success'),
                text: i18n.get('contacts.you_will_be_redirected'),
                timer: 4000,
            }).then(() => {
                window.location.href = props.redirectAfterSubmit
            })
        }).catch(() => {
            swal({
                icon: "error",
                title: i18n.get('contacts.ajax_error'),
            })
        })
    },

    validateOnBlur: true

})(CustomerForm)

const styles = theme => ({
    deleteButton: {
        // background: theme.colors.error
    }
});

export default withStyles(styles)(FormConfig)



// WEBPACK FOOTER //
// ./resources/assets/js/components/Customers/CustomerForm.js